// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// TODO: Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAf7OjMt-SWQ03MGJ5jouYBbwMKRvPv8_o",
  authDomain: "farzl-industrial.firebaseapp.com",
  projectId: "farzl-industrial",
  storageBucket: "farzl-industrial.firebasestorage.app",
  messagingSenderId: "482954014564",
  appId: "1:482954014564:web:8c6ecbbea2b07e61685471"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
